import { QuickActionsNav } from '@/components/quick-actions-nav';
import { MyProfileAvatar } from '@/components/my-profile-avatar';

import { useGetDevicesQuery } from '@/features/devices/hooks/queries/get-all-devices.ts';
import { DevicesList } from '@/features/devices/components/devices-list.tsx';

const Devices = () => {
  const { data: devices, isLoading } = useGetDevicesQuery();

  return (
    <div className="overview w-full gap-2 overflow-auto px-4 pt-3 pb-8 sm:px-6">
      <div className="flex flex-col gap-6">
        <div className="flex h-[45px] items-center justify-between">
          <h1 className="text-xl font-bold sm:text-2xl">Devices</h1>
          <div className="flex gap-2">
            <QuickActionsNav />
            <MyProfileAvatar />
          </div>
        </div>
        <div>
          <DevicesList devices={devices || []} isLoading={isLoading} />
        </div>
      </div>
    </div>
  );
};

export default Devices;
